//@flow
import BaseEntitySelectors from 'common/redux/selectors/BaseEntitySelectors';
import { createSelector } from 'reselect';
import {
    clientSelector,
    teamIdQuerySelector,
    homebaseIdQuerySelector
} from 'common/redux/selectors/queryParamsSelectors';
import { ZoneMap } from 'common/models/internal/ZoneMap';
import { ZoneMapGeometryStatusEnum } from 'common/enums/ZoneMapGeometryStatus';
import DataUtils from 'common/utils/DataUtils';
import { getHomebasesIfPresent } from 'common/redux/selectors/homebase';
class ZoneMapSelectors extends BaseEntitySelectors {
    constructor() {
        super('zoneMap');
    }

    getIsEntityVersionsLoading = createSelector(
        [this.storeSelector, clientSelector, (_, props) => props.mapId],
        (entityState, clientId, mapId) => {
            return entityState.getIn([
                'records',
                clientId,
                'entities',
                'versions',
                mapId,
                'status',
                'isLoading'
            ]);
        }
    );

    getEntityVersions = createSelector(
        [this.storeSelector, clientSelector, (_, props) => props.mapId],
        (entityState, clientId, mapId) => {
            return entityState.getIn([
                'records',
                clientId,
                'entities',
                'versions',
                mapId,
                'records'
            ]);
        }
    );
    getFullMapsRecords = createSelector(
        [clientSelector, this.storeSelector],
        (clientId, entityStore) => {
            return entityStore.getIn([
                'records',
                clientId,
                'entities',
                'fullRecords'
            ]);
        }
    );
    getSelectedMap = createSelector(
        [
            this.getFullMapsRecords,
            (_, props) => props.match.params.mapId,
            teamIdQuerySelector,
            homebaseIdQuerySelector,
            clientSelector
        ],
        (entities, mapId, teamId, homebaseId, clientId) => {
            // creating a new map
            let selectedMap = null;
            if (!DataUtils.isEmpty(teamId) && !DataUtils.isEmpty(homebaseId)) {
                selectedMap = ZoneMap.fromJS({
                    clientId,
                    teamId: { teamId, clientId },
                    homebaseId: { locationId: homebaseId, clientId },
                    status: ZoneMapGeometryStatusEnum.Active
                });
                return selectedMap;
            }

            if (entities && entities.fullMaps) {
                selectedMap = entities.fullMaps.find(
                    entity => entity.id === mapId
                );
            }
            return selectedMap;
        }
    );

    getSelectedMapHomebaseId = createSelector(
        [this.getSelectedMap],
        selectedMap => {
            return selectedMap && selectedMap.homebaseId.locationId;
        }
    );

    getSelectedMapHomebase = createSelector(
        [this.getSelectedMapHomebaseId, getHomebasesIfPresent],
        (homebaseId, homebases) => {
            return (
                homebaseId &&
                homebases &&
                homebases.find(homebase => homebase.id === homebaseId)
            );
        }
    );

    isSelectedMapLoading = createSelector(
        [this.storeSelector, clientSelector],
        (entityState, clientId) => {
            return entityState.getIn([
                'records',
                clientId,
                'entities',
                'status',
                'isFullMapLoading'
            ]);
        }
    );

    selectedMapErrorSelector = createSelector(
        [this.storeSelector, clientSelector],
        (entityState, clientId) => {
            return entityState.getIn([
                'records',
                clientId,
                'entities',
                'fullMapError'
            ]);
        }
    );

    getUsecasesMap = createSelector(
        [this.storeSelector, clientSelector],
        (entityState, clientId) => {
            return entityState.getIn([
                'records',
                clientId,
                'entities',
                'usecasesMap'
            ]);
        }
    );
    isSettingMapUsecases = createSelector(
        [this.storeSelector, clientSelector, (_, props) => props.mapId],
        (entityState, clientId, mapId) => {
            return entityState.getIn([
                'records',
                clientId,
                'entities',
                mapId,
                'activeUsescases',
                'status',
                'isLoading'
            ]);
        }
    );

    isDeletingEntity = createSelector(
        [this.storeSelector, clientSelector],
        (entityState, clientId) => {
            return entityState.getIn([
                'records',
                clientId,
                'entities',
                'status',
                'isDeletingEntity'
            ]);
        }
    );
}

export default new ZoneMapSelectors();
